export default {
  title: {
    step1Identity: 'Identificación',
    redirect: 'Redirigiendo',
    step2Approved: 'Subida documentación Operación Aprobada',
    step2Study: 'Subida documentación Operación En Estudio',
    step4: 'Resumen',
    step5: 'Gracias',
    step3: 'Gracias por subir la documentación',
    notFound: 'No encontrada',
    error: 'Error',
    legal: 'Legal'
  },
  message: {
    generic: {
      loadingData: 'Cargando datos'
    },
    study: {
      response:
        '<b>¡Gracias!</b></br>Tu documentación ha sido remitida y contactaremos antes de 48 horas laborables con el resultado del análisis de su operación.</br>Para cualquier duda, póngase en contacto con tu agente comercial.'
    }
  },
  language: {
    en: 'Inglés',
    es: 'Español'
  },
  ui: {
    button: {
      btnBack: 'Volver',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      btnAccept: 'Aceptar',
      btnClose: 'Cerrar',
      btnCreate: 'Crear',
      btnConfirm: 'Confirmar',
      btnContract: 'Contratar',
      btnChange: 'Cambiar',
      btnDelete: 'Eliminar',
      btnRecord: 'Grabar',
      btnClear: 'Limpiar',
      btnAcceptRecord: 'Aceptar y Grabar',
      btnAddAttorney: 'Añadir nuevo apoderado',
      btnRemoveAttorney: 'Quitar apoderado',
      btnDownload: 'Descargar',
      btnPreContractualInfo: 'Información precontractual',
      btnTelephone: '910 554 977',
      btnEmail: 'campanas@bbvaautorenting.es'
    },
    label: {
      operationNumber: 'N° Operación:',
      docTitle: 'DOCUMENTACIÓN ADJUNTA.',
      docText: 'Adjunta los ficheros que a continuación te solicitamos.',
      infoData: 'Resumen de Información',
      deliveryMethod: 'Forma de entrega elegida:',
      addressSend: 'Dirección de envío:',
      paymentMethod: 'Forma de pago elegida:',
      congratulations: '¡Enhorabuena',
      textFinish: 'Tu proceso ha terminado'
    },
    placeholder: {
      genre: 'Género',
      profession: 'Ocupación',
      birthDate: 'Fecha de nacimiento',
      maritalStatus: 'Estado Civil',
      email: 'Email',
      mobilePhone: 'Móvil',
      streetType: 'Tipo de vía',
      address: 'Dirección',
      postCode: 'Código postal',
      town: 'Localidad',
      financialIncomes: 'Ingresos Mensuales',
      antiquity: 'Antigüedad',
      dateRetirement: 'Fecha jubilación',
      companyNameLast: 'Nombre de última empresa',
      dateRegistration: 'Fecha alta IAE',
      companyExercise: 'Actividad (Indicar código CNAE)',
      companyName: 'Nombre de la empresa',
      dealerCode: 'Código de gestor',
      name: 'Nombre',
      surname: 'Primer apellido',
      surname2: 'Segundo apellido',
      documentTypes: 'Tipo de documento',
      documentId: 'Número {document}',
      documentIdGlobal: 'Número de documento (DNI, NIE)',
      businessName: 'Razón social',
      cif: 'CIF',
      constitutionDate: 'Fecha de constitución',
      fax: 'Fax',
      registeredOffice: 'Domicilio Social',
      signType: 'Tipo de firma',
      phone: 'Teléfono',
      issueDate: 'Fecha de emisión',
      showFiles: 'Ver documentos'
    }
  },
  error: {
    undefined: 'Ups... ¡Algo salió mal!',
    notFound: 'Esta página no existe'
  },
  success: {}
};
